<template>
  <div>
    <div class="main">
      <div class="form-row-parse">
        <div class="form-button-parse">
          <button @click="addPlantsToDB" class="add" v-show="showButtonAddToDB">
            Добавить участки
          </button>
        </div>
        <div class="form-button-parse" v-show="info">
          {{ info }}
          <router-link
            class="clear"
            :to="'/admin/map/addvillage/4?village_id=' + idVillage"
          >
            <span>Продолжить</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="main_control_panel">
      <div class="data_select_element" v-show="selectElementOb">
        <button @click="closeSelectData" class="close_select_data">X</button>
        <pre>{{ dataSelectElement | pretty }}</pre>
      </div>
      <div class="control_panel" v-show="landsChoseToEdit.length">
        <button class="cancel" @click="cancel">
          Отмена
        </button>
        <button class="delete" @click="deleteChoseArea">
          Удалить выделенные объекты
        </button>
      </div>
      <yandex-map
        map-type="hybrid"
        :coords="coordsCenter"
        :zoom="12"
        :controls="[]"
        @map-was-initialized="firstMapInit"
      >
        <ymap-marker
          v-for="(item, index) in showVillageBound"
          :coords="item.coordinates"
          :marker-type="item.type"
          :options="overlayVillage"
          :properties="{ type: 'village' }"
          :marker-id="index"
          v-bind:key="index + 'village'"
          @click="clickVillage"
        />
        <ymap-marker
          v-for="(item, index) in plants"
          :coords="item.coordinates"
          :marker-type="item.type"
          :options="overlayPlant"
          :properties="{
            type: 'plot',
            data: item.data,
            id: item.id,
            delete: 'N'
          }"
          :marker-id="index"
          :key="index + 'plot'"
          @click="clickPolygon"
          @click.right="clickRightButton"
        />
      </yandex-map>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import { yandexMap, ymapMarker } from "vue-yandex-maps";

export default {
  name: "AddVillageCoord",
  components: { yandexMap, ymapMarker },
  data() {
    return {
      info: null,
      success: false,
      map: false,
      plantsData: {},
      landsChoseToEdit: [],
      landsDeleted: [],
      selectElementOb: false,
      fillColor: "#307c0d",
      fillColorChosed: "#7c0d16",
      fillColorSelect: "#b9b9b9",
      idVillage: null,
      idDistrict: null,
      idRegion: null,
      villages: [],
      districts: [],
      regions: [],
      plants: [],
      showVillageBound: [],
      url: config.backend_url,
      coords: [55.755819, 37.617644],
      coordsCenter: [55.755819, 37.617644],
      overlayVillage: {
        fillColor: "#7c270d",
        strokeColor: "#fcfcfc",
        fillOpacity: 0.5,
        strokeWidth: 1
      },
      overlayPlant: {
        fillColor: "#307c0d",
        strokeColor: "#fcfcfc",
        fillOpacity: 0.5,
        strokeWidth: 1
      }
    };
  },
  computed: {
    dataSelectElement: function() {
      return this.selectElementOb
        ? this.selectElementOb.properties.get("data")
        : false;
    },
    showButtonAddToDB: function() {
      return this.plants.length > 0 && !this.success;
    }
  },
  methods: {
    clickPolygon(e) {
      let element = e.get("target");
      if (this.selectElementOb === element) {
        element.options.set("fillColor", this.fillColor);
        element.properties.set("selected", "N");
        this.selectElementOb = false;
      } else {
        this.selectElementOb = element;
        this.unselectElements();
        element.options.set("fillColor", this.fillColorSelect);
        element.properties.set("selected", "Y");
      }
    },
    clickVillage(e) {
      let self = this;
      let element = e.get("target");
      if (element.properties.get("editing") !== "Y") {
        element.properties.set("editing", "Y");
        element.editor.startEditing();

        let buttonSaveArea = new window.ymaps.control.Button({
          data: { content: "Сохранить границы" },
          options: { maxWidth: 150 }
        });
        buttonSaveArea.events.add("click", function() {
          let coordinates = element.geometry.getCoordinates();
          let saveData = {};
          let geometries = [];
          saveData.type = "Polygon";
          saveData.coordsCenter = self.coordsCenter;
          saveData.coordinates = coordinates;
          element.editor.stopEditing();
          geometries.push(saveData);
          self.updateVillage(geometries);
          self.map.controls.remove(buttonSaveArea);
          element.properties.set("editing", "N");
        });
        this.map.controls.add(buttonSaveArea);
      }
    },
    closeSelectData() {
      this.selectElementOb.properties.set("selected", "N");
      this.selectElementOb.options.set("fillColor", this.fillColor);
      this.selectElementOb = false;
    },
    unselectElements() {
      let self = this;
      this.map.geoObjects.each(function(geoCollection) {
        geoCollection.each(function(ob) {
          if (ob.properties.get("selected") === "Y") {
            ob.properties.set("selected", "N");
            ob.options.set("fillColor", self.fillColor);
          }
        });
      });
    },
    clickRightButton(e) {
      let element = e.get("target");
      let id = element.properties.get("id");
      if (this.landsChoseToEdit.includes(id)) {
        this.landsChoseToEdit.splice(this.landsChoseToEdit.indexOf(id), 1);
        element.options.set("fillColor", this.fillColor);
        element.properties.set("delete", "N");
      } else {
        this.landsChoseToEdit.push(id);
        element.options.set("fillColor", this.fillColorChosed);
        element.properties.set("delete", "Y");
      }
    },
    deleteChoseArea() {
      let self = this;

      /*let objects = window.ymaps.geoQuery(this.map.geoObjects);
      let otherObjects = objects
        .search("properties.type = 'plot'")
        .search("properties.delete = 'Y'");
      console.log(otherObjects);
      otherObjects.removeFromMap(this.map);*/

      this.map.geoObjects.each(function(geoCollection) {
        geoCollection.each(function(ob) {
          if (ob.properties.get("delete") === "Y") {
            geoCollection.remove(ob);
          }
        });
      });
      this.landsChoseToEdit.forEach(function(item) {
        self.landsDeleted.push(item);
      });
      this.landsChoseToEdit = [];
    },
    cancel() {
      let self = this;
      this.map.geoObjects.each(function(geoCollection) {
        geoCollection.each(function(ob) {
          ob.options.set("fillColor", self.fillColor);
          ob.properties.set("delete", "N");
        });
      });
      this.landsChoseToEdit = [];
    },
    firstMapInit: function(map) {
      this.map = map;
    },
    addPlantsToDB: function() {
      let self = this;
      let addData = this.plantsData.filter(function(value) {
        return !self.landsDeleted.includes(parseInt(value.ID));
      });
      let elementsData = [];
      for (const [key, value] of Object.entries(addData)) {
        let valueCoord = {};
        valueCoord.NAME = value.ID;
        valueCoord.KADASTR = value.CADASTR;
        valueCoord.COORDINATES = value.COORDINATES;
        valueCoord.VILLAGE = self.idVillage;
        elementsData.push(valueCoord);
      }
      let data = {
        url: self.url + "plots/process-multi/",
        data: elementsData,
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        if (!data.error) {
          self.info = "Участки добавлены";
          self.success = true;
        }
      });
    },
    addPlantsToMap: function() {
      let self = this;
      let data = {
        url: self.url + "cadastr/get-plants-to-village/",
        filter: { ID: self.idVillage },
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        self.plantsData = data;
        if (!data.error) {
          let elementsData = [];
          for (const [key, value] of Object.entries(data)) {
            let coord = JSON.parse(value.COORDINATES);
            let data = JSON.parse(value.DATA);
            let valueCoord = {};
            valueCoord.name = value.CADASTR;
            valueCoord.data = data;
            valueCoord.type = "Polygon";
            valueCoord.id = parseInt(value.ID);
            valueCoord.coordinates = [];
            valueCoord.coordinates.push(coord);
            elementsData.push(valueCoord);
          }
          self.plants = elementsData;
        }
      });
    },
    getVillages: function() {
      let self = this;
      let data = {
        url: self.url + "villages/get/",
        filter: { DISTRICT: self.idDistrict },
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        if (!data.error) {
          self.villages = data;
          self.showVillages();
        }
      });
    },
    showVillages: function() {
      let self = this;
      let village = this.villages[this.idVillage];
      let geoCoord = JSON.parse(village.GEO_COORD);
      this.coordsCenter = geoCoord[0].coordsCenter;
      this.showVillageBound = geoCoord;
      this.addPlantsToMap();
      setTimeout(function() {
        self.map.setBounds(self.map.geoObjects.getBounds());
      }, 500);
    },
    updateVillage: function(geometries) {
      let self = this;
      let data = {
        url: self.url + "villages/update/",
        data: {
          ID: this.idVillage,
          GEO_COORD: JSON.stringify(geometries)
        },
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        console.log(data);
      });
    }
  },
  created() {
    this.idVillage = this.$route.query.village_id;
    this.getVillages();
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(value, null, 2);
    }
  }
};
</script>

<style scoped></style>
